// ()=>import Layout from '../views/components/mainLayout/Layout.vue';

const prefixConsoleHome = 'console.home';
const prefixConsoleRisk = 'console.carRisk';
const prefixConsoleWarning = 'console.warning';
const prefixConsoleDevice = 'console.device';
const prefixConsoleStatistics = 'console.statistics';
const prefixConsoleFault = 'console.fault';
const prefixConsoleSetting = 'console.setting';
const prefixConsoleIntellectControl = 'console.intellectControl';
const prefixConsoleVehicleMonitor = 'console.vehicleMonitor';

export default [
  {
    path: '/console/home',
    name: `${prefixConsoleHome}`,
    component: () => import('@/views/console/home/Index.vue'),
    hidden: false,
    meta: {
      title: '首页',
      keepAlive: false,
      icon: 'el-icon-house',
      contentClass: 'bg-transparent',
    },
    alwaysShow: true,
    showSingle: true,
  },
  {
    component: () => import('@/views/console/carRisk/HistoricalTrack.vue'),
    name: `${prefixConsoleRisk}`,
    hidden: false,
    path: '/console/carRisk/',
    meta: {
      title: '车辆风控',
      keepAlive: false,
      icon: 'el-icon-user-solid',
    },
    // showSingle:false,
    alwaysShow: true,
  },

  {
    path: '/console/carRisk/realtimeControl',
    name: `${prefixConsoleRisk}.realtimeControl`,
    meta: {
      id: 5,
      title: '车辆实时风控',
      keepAlive: false,
      icon: 'el-icon-user-solid',
      noCache: true,
    },
    component: () => import('@/views/console/carRisk/RealtimeControl.vue'),
    hidden: false,
    // showSingle:false,
    alwaysShow: false,
  },
  {
    path: '/console/carRisk/historicalTrack',
    name: `${prefixConsoleRisk}.historicalTrack`,
    meta: {
      id: 6,
      title: '车辆轨迹查询',
      icon: '',
    },
    component: () => import('@/views/console/carRisk/HistoricalTrack.vue'),
    hidden: false,
    // showSingle:false,
    alwaysShow: false,
  },
  // 报警管理
  {
    component: () => import('@/views/console/warning/History.vue'),
    name: `${prefixConsoleWarning}`,
    hidden: false,
    path: '/console/warning/',
    meta: {
      title: '报警管理',
      keepAlive: false,
      icon: 'el-icon-bell',
    },
    // showSingle:false,
    alwaysShow: true,
  },
  {
    component: () => import('@/views/console/warning/History.vue'),
    name: `${prefixConsoleWarning}.history`,
    hidden: false,
    path: '/console/warning/history',
    meta: {
      title: '报警历史记录',
      keepAlive: false,
      icon: '',
    },
    // showSingle:false,
    alwaysShow: true,
  },
  {
    component: () => import('@/views/console/warning/Setting.vue'),
    name: `${prefixConsoleWarning}.setting`,
    hidden: false,
    path: '/console/warning/setting',
    meta: {
      title: '报警设置',
      keepAlive: false,
      icon: '',
    },
    // showSingle:false,
    alwaysShow: true,
  },
  {
    component: () => import('@/views/console/warning/Realtime.vue'),
    name: `${prefixConsoleWarning}.realtime`,
    hidden: false,
    path: '/console/warning/realtime',
    meta: {
      title: '报警实时风控',
      keepAlive: false,
      icon: '',
    },
    // showSingle:false,
    alwaysShow: true,
  },
  // 统计报表
  {
    component: () => import('@/views/console/statistics/Address.vue'),
    name: `${prefixConsoleStatistics}`,
    hidden: false,
    path: '/console/statistics/',
    meta: {
      title: '统计报表',
      keepAlive: false,
      icon: 'el-icon-s-data',
    },
    // showSingle:false,
    alwaysShow: true,
  },
  {
    component: () => import('@/views/console/statistics/Address.vue'),
    name: `${prefixConsoleStatistics}.address`,
    hidden: false,
    path: '/console/statistics/address',
    meta: {
      title: '常去地点分析',
      keepAlive: false,
      icon: '',
    },
    // showSingle:false,
    alwaysShow: true,
  },
  {
    component: () => import('@/views/console/statistics/Mileage.vue'),
    name: `${prefixConsoleStatistics}.mileage`,
    hidden: false,
    path: '/console/statistics/mileage',
    meta: {
      title: '车辆里程统计',
      keepAlive: false,
      icon: '',
    },
    // showSingle:false,
    alwaysShow: true,
  },
  {
    component: () => import('@/views/console/statistics/OffLine.vue'),
    name: `${prefixConsoleStatistics}.offLine`,
    hidden: false,
    path: '/console/statistics/offLine',
    meta: {
      title: '车辆离线统计',
      keepAlive: false,
      icon: '',
    },
    // showSingle:false,
    alwaysShow: true,
  },
  {
    component: () => import('@/views/console/statistics/ImportantCar.vue'),
    name: `${prefixConsoleStatistics}.importantCar`,
    hidden: false,
    path: '/console/statistics/importantCar',
    meta: {
      title: '重点关注车辆统计',
      keepAlive: false,
      icon: '',
    },
    // showSingle:false,
    alwaysShow: true,
  },
  {
    component: () => import('@/views/console/statistics/VehicleCycling.vue'),
    name: `${prefixConsoleStatistics}.vehicleCycling`,
    hidden: false,
    path: '/console/statistics/vehicleCycling',
    meta: {
      title: '车辆骑行时段分析',
      keepAlive: false,
      icon: '',
    },
    // showSingle:false,
    alwaysShow: true,
  },
  {
    component: () => import('@/views/console/statistics/ModelCycling.vue'),
    name: `${prefixConsoleStatistics}.modelCycling`,
    hidden: false,
    path: '/console/statistics/modelCycling',
    meta: {
      title: '车型骑行时段分析',
      keepAlive: false,
      icon: '',
    },
    // showSingle:false,
    alwaysShow: true,
  },
  {
    component: () => import('@/views/console/statistics/Region.vue'),
    name: `${prefixConsoleStatistics}.region`,
    hidden: false,
    path: '/console/statistics/region',
    meta: {
      title: '骑行区域分析',
      keepAlive: false,
      icon: '',
    },
    // showSingle:false,
    alwaysShow: true,
  },
  // 设备管理
  {
    component: () => import('@/views/console/device/VehicleList.vue'),
    name: `${prefixConsoleDevice}`,
    hidden: false,
    path: '/console/device/',
    meta: {
      title: '设备管理',
      icon: 'el-icon-s-management',
    },
    // showSingle:false,
    alwaysShow: true,
  },

  {
    path: '/console/device/vehicleList',
    name: `${prefixConsoleDevice}.vehicleList`,
    meta: {
      id: 7,
      title: '设备列表',
      keepAlive: true,
      icon: '',
      noCache: true,
    },
    component: () => import('@/views/console/device/VehicleList.vue'),
    hidden: false,
    // showSingle:false,
    alwaysShow: false,
  },

  // 故障管理
  {
    component: () => import('@/views/console/fault/History.vue'),
    name: `${prefixConsoleFault}`,
    hidden: false,
    path: '/console/fault/',
    meta: {
      title: '故障管理',
      keepAlive: false,
      icon: 'el-icon-cpu',
    },
    // showSingle:false,
    alwaysShow: true,
  },
  {
    component: () => import('@/views/console/fault/Realtime.vue'),
    name: `${prefixConsoleFault}.realtime`,
    hidden: false,
    path: '/console/fault/realtime',
    meta: {
      title: '故障实时风控',
      keepAlive: false,
      icon: '',
    },
    // showSingle:false,
    alwaysShow: true,
  },
  {
    component: () => import('@/views/console/fault/History.vue'),
    name: `${prefixConsoleFault}.history`,
    hidden: false,
    path: '/console/fault/history',
    meta: {
      title: '故障历史记录',
      keepAlive: false,
      icon: '',
    },
    // showSingle:false,
    alwaysShow: true,
  },
  {
    component: () => import('@/views/console/fault/odo/Index.vue'),
    name: `${prefixConsoleFault}.odo`,
    hidden: false,
    path: '/console/fault/odo',
    meta: {
      title: 'ODO数据故障',
      keepAlive: false,
      icon: '',
    },
    // showSingle:false,
    alwaysShow: true,
  },
  // 全局设置
  {
    component: () => import('@/views/console/setting/QuickDeal.vue'),
    name: `${prefixConsoleSetting}`,
    hidden: false,
    path: '/console/setting/',
    meta: {
      title: '全局设置',
      keepAlive: false,
      icon: 'el-icon-setting',
    },
    // showSingle:false,
    alwaysShow: true,
  },
  {
    path: '/console/setting/quickDeal',
    name: `${prefixConsoleSetting}.quickDeal`,
    hidden: false,
    meta: {
      id: 8,
      title: '快捷处理设置',
      keepAlive: true,
      icon: '',
      noCache: true,
    },
    component: () => import('@/views/console/setting/QuickDeal.vue'),
    // showSingle:false,
    alwaysShow: false,
  },
  {
    path: '/console/intellectControl/default',
    name: `${prefixConsoleIntellectControl}.default`,
    hidden: false,
    meta: {
      title: '智能中控信息查询',
      keepAlive: false,
      icon: '',
      noCache: true,
    },
    component: () => import('@/views/console/intellectControl/default/Index.vue'),
    // showSingle:false,
    alwaysShow: false,
  },
  {
    path: '/console/intellectControl/default/detail/:areaNodeId-:deviceName',
    name: `${prefixConsoleIntellectControl}.default.detail`,
    hidden: false,
    meta: {
      title: '智能中控信息详情',
      keepAlive: false,
      icon: '',
      noCache: true,
    },
    component: () => import('@/views/console/intellectControl/default/Detail.vue'),
    // showSingle:false,
    alwaysShow: false,
  },
  {
    path: '/console/vehicleMonitor/faultMonitor',
    name: `${prefixConsoleVehicleMonitor}.faultMonitor`,
    hidden: false,
    meta: {
      title: '故障监控',
      keepAlive: false,
      icon: '',
      noCache: true,
      contentClass: 'bg-transparent',
    },
    component: () => import('@/views/console/vehicleMonitor/faultMonitor/Index.vue'),
    // showSingle:false,
    alwaysShow: false,
  },
  {
    path: '/console/vehicleMonitor/faultMonitor/type/:vehicleMonitorProjectId',
    name: `${prefixConsoleVehicleMonitor}.faultMonitor.type`,
    hidden: false,
    meta: {
      title: '故障监控类型',
      keepAlive: false,
      icon: '',
      noCache: true,
      contentClass: 'bg-transparent',
    },
    component: () => import('@/views/console/vehicleMonitor/faultMonitor/Type.vue'),
    // showSingle:false,
    alwaysShow: false,
  },
  {
    path: '/console/vehicleMonitor/faultMonitor/detail/:vehicleMonitorProjectId/:id',
    name: `${prefixConsoleVehicleMonitor}.faultMonitor.detail`,
    hidden: false,
    meta: {
      title: '故障监控详情',
      keepAlive: false,
      icon: '',
      noCache: true,
      contentClass: 'bg-transparent',
    },
    component: () => import('@/views/console/vehicleMonitor/faultMonitor/Detail.vue'),
    // showSingle:false,
    alwaysShow: false,
  },
  {
    path: '/console/vehicleMonitor/accident',
    name: `${prefixConsoleVehicleMonitor}.accident`,
    hidden: false,
    meta: {
      title: '事故监控',
      keepAlive: false,
      icon: '',
      noCache: true,
      contentClass: 'bg-transparent',
    },
    component: () => import('@/views/console/vehicleMonitor/accident/Index.vue'),
    // showSingle:false,
    alwaysShow: false,
  },
  {
    path: '/console/vehicleMonitor/vehicleReportManage',
    name: `${prefixConsoleVehicleMonitor}.vehicleReportManage`,
    hidden: false,
    meta: {
      title: '车辆播报管理',
      keepAlive: false,
      icon: '',
      noCache: true,
    },
    component: () => import('@/views/console/vehicleMonitor/vehicleReportManage/Index.vue'),
    alwaysShow: false,
  },
  {
    path: '/console/vehicleMonitor/reportControlClassify',
    name: `${prefixConsoleVehicleMonitor}.reportControlClassify`,
    hidden: false,
    meta: {
      title: '播报控制分类',
      keepAlive: false,
      icon: '',
      noCache: true,
    },
    component: () => import('@/views/console/vehicleMonitor/reportControlClassify/Index.vue'),
    alwaysShow: false,
  },
];
